import {
  Component,
  OnInit,
  ElementRef,
  ViewChild,
  ViewChildren,
  QueryList,
  ChangeDetectionStrategy
} from '@angular/core';
import Splide from '@splidejs/splide';
import { AnimationService } from 'src/app/services/animation/animation.service';

@Component({
  selector: 'app-hospitality',
  templateUrl: './hospitality.component.html',
  styleUrls: ['./hospitality.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class HospitalityComponent implements OnInit {
  slideConfig: any = {};
  constructor(
    private elementRef: ElementRef,
    private animate: AnimationService
  ) {}
  @ViewChild('test') test!: ElementRef;
  @ViewChildren('textContent') textContent!: QueryList<ElementRef>;

  ngOnInit(): void {}

  ngAfterViewInit(): void {
    const elements = this.textContent.toArray().map((el) => el.nativeElement);
    if (elements) {
      this.animate.fadeInElementsImmediate(elements, 0.05);
      console.log('1st');
    }
  }
}
